'use client';

export const getUTMs = (): Record<string, string> => {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  const utmParams = Array.from(params.entries()).filter(([key]) => key.toLowerCase().startsWith('utm_'));

  const utms = utmParams.reduce((acc, [key, value]) => {
    acc[key] = value;

    return acc;
  }, {} as Record<string, string>);

  return utms;
};
